import { type ReactElement } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { Button, Icon, Popover } from '@wf/components';

import { isChildLpcoSelector, parentLpcoAttachmentsSelector } from '../../../store/selectors';

import styles from './AttachNewDocumentButton.module.scss';

interface IAttachNewDocumentButtonProps {
  onClick: () => void; // upload button click handler
  onImport: () => void; // import button click handler
  leftIcon?: ReactElement;
  className?: string;
}

function AttachNewDocumentButton({ onClick, className, leftIcon, onImport }: IAttachNewDocumentButtonProps) {
  const { t } = useTranslation();
  const isChildLpco = useSelector(isChildLpcoSelector);
  const parentAttachments = useSelector(parentLpcoAttachmentsSelector);

  return (
    <>
      {isChildLpco && parentAttachments?.length ? (
        <Popover className={cn(styles.popover, className)}>
          <Popover.Target>
            {({ isActive }) => (
              <Button
                rightIcon={<Icon name={isActive ? 'ic_arrow_small_up' : 'ic_arrow_small_down'} />}
                leftIcon={leftIcon}
              >
                {t('Attach new document')}
              </Button>
            )}
          </Popover.Target>
          <Popover.Content className={styles.content}>
            {({ close }) => (
              <>
                <Button
                  onClick={() => {
                    onClick();
                    close();
                  }}
                  color="typography"
                  ghost
                >
                  {t('Upload')}
                </Button>
                <Button
                  onClick={() => {
                    onImport();
                    close();
                  }}
                  color="typography"
                  ghost
                >
                  {t('Import Documents from Parent LPCO')}
                </Button>
              </>
            )}
          </Popover.Content>
        </Popover>
      ) : (
        <Button onClick={onClick} className={className} leftIcon={leftIcon}>
          {t('Attach new document')}
        </Button>
      )}
    </>
  );
}

export default AttachNewDocumentButton;
